import { useEffect, useState, useRef } from "react";
import { functions } from "../../../constants/common-functions";

export default function useInsights()
{
    const [insightsByCategory, setInsightsByCategory] =
        useState([]);

    const [insightList, setInsightList] =
        useState([]);

    const [panoramaInsightList, setPanoramaInsightList] =
        useState([]);

    const [insight, setInsight] =
        useState(null);

    const [loading, setLoading] =
        useState(true);

    const [insightListLoading, setInsightListLoading] =
        useState(false);

    const [
        panoramaInsightListLoading,
        setPanoramaInsightListLoading
    ] =
        useState(false);

    const [insightLoading, setInsightLoading] =
        useState(false);
		
		
		const [panoramaObservationList, setPanoramaObservationList] =
		    useState([]);

		const [panoramaPotentialAssetList, setPanoramaPotentialAssetList] =
		    useState([]);

		const [
		    panoramaObservationListLoading,
		    setPanoramaObservationListLoading
		] =
		    useState(false);

		const [
		    panoramaPotentialAssetListLoading,
		    setPanoramaPotentialAssetListLoading
		] =
		    useState(false);


		const panoramaObservationRequestId =
		    useRef(0);

		const panoramaPotentialAssetRequestId =
		    useRef(0);
		
	const panoramaRequestId =
	    useRef(0);
		
		
		const [dashboard, setDashboard] =
		    useState(null);

		const [dashboardLoading, setDashboardLoading] =
		    useState(false);


    //--------------------------------------------------------
    // Initial load
    //--------------------------------------------------------

    useEffect(() =>
    {
        loadInsightsByCategory();
    }, []);


    //--------------------------------------------------------
    // Totals by category
    //--------------------------------------------------------

    function loadInsightsByCategory()
    {
        setLoading(true);

        functions.getArrayFromAjax(
            "/resolutionsoftwareplatform/insights/totalbycategory",

            (data) =>
            {
                setInsightsByCategory(data);
                setLoading(false);
            },

            null
        );
    }


    //--------------------------------------------------------
    // Insight list for category
    //--------------------------------------------------------

    function loadInsightListForCategory(category)
    {
        setInsightListLoading(true);

        functions.getArrayFromAjax(
            "/resolutionsoftwareplatform/insights/listbycategory?category="
            +
            encodeURIComponent(category),

            (data) =>
            {
                setInsightList(data);
                setInsightListLoading(false);
            },

            null
        );
    }


    //--------------------------------------------------------
    // Insight list for panorama
    //--------------------------------------------------------

	function loadInsightListForPanorama(
	    giraffePanoramaId)
	{
	    if(
	        giraffePanoramaId === null
	        ||
	        giraffePanoramaId === undefined
	        ||
	        giraffePanoramaId === ""
	    )
	    {
	        panoramaRequestId.current++;

	        setPanoramaInsightList([]);
	        setPanoramaInsightListLoading(false);

	        return;
	    }

	    const requestId =
	        ++panoramaRequestId.current;

	    const loadingStarted =
	        Date.now();

	    const minimumLoadingTime =
	        2000;

	    setPanoramaInsightListLoading(true);

	    functions.getArrayFromAjax(
	        "/resolutionsoftwareplatform/insights/listbypanorama"
	        +
	        "?giraffePanoramaId="
	        +
	        encodeURIComponent(giraffePanoramaId),

	        (data) =>
	        {
	            const elapsed =
	                Date.now() - loadingStarted;

	            const remaining =
	                Math.max(
	                    0,
	                    minimumLoadingTime - elapsed
	                );

	            window.setTimeout(
	                () =>
	                {
	                    /*
	                     * Ignore an obsolete result if the user
	                     * has already moved to another panorama.
	                     */

	                    if(
	                        requestId
	                        !==
	                        panoramaRequestId.current
	                    )
	                    {
	                        return;
	                    }

	                    setPanoramaInsightList(
	                        Array.isArray(data)
	                            ?
	                            data
	                            :
	                            []
	                    );

	                    setPanoramaInsightListLoading(false);
	                },
	                remaining
	            );
	        },

	        null
	    );
	}


    //--------------------------------------------------------
    // Individual insight
    //--------------------------------------------------------

    function loadInsight(id)
    {
        if(id === null || id === undefined)
        {
            setInsight(null);
            return;
        }

        setInsightLoading(true);
        setInsight(null);

        functions.getObjectFromAjax(
            "/resolutionsoftwareplatform/insights/insight?id="
            +
            encodeURIComponent(id),

            (data) =>
            {
                setInsight(data);
                setInsightLoading(false);
            },

            null
        );
    }


    //--------------------------------------------------------
    // Clear panorama insight list
    //--------------------------------------------------------

    function clearPanoramaInsightList()
    {
        setPanoramaInsightList([]);
        setPanoramaInsightListLoading(false);
    }


    //--------------------------------------------------------
    // Clear selected insight
    //--------------------------------------------------------

    function clearInsight()
    {
        setInsight(null);
        setInsightLoading(false);
    }
	
	
	//--------------------------------------------------------
	// Observation list for panorama
	//--------------------------------------------------------

	function loadObservationListForPanorama(
	    giraffePanoramaId)
	{
	    if(
	        giraffePanoramaId === null
	        ||
	        giraffePanoramaId === undefined
	        ||
	        giraffePanoramaId === ""
	    )
	    {
	        panoramaObservationRequestId.current++;

	        setPanoramaObservationList([]);
	        setPanoramaObservationListLoading(false);

	        return;
	    }

	    const requestId =
	        ++panoramaObservationRequestId.current;

	    const loadingStarted =
	        Date.now();

	    const minimumLoadingTime =
	        2000;

	    setPanoramaObservationListLoading(true);
		
	    functions.getArrayFromAjax(
	        "/resolutionsoftwareplatform/observations/listbypanorama"
	        +
	        "?giraffePanoramaId="
	        +
	        encodeURIComponent(giraffePanoramaId),

	        (data) =>
	        {
	            const elapsed =
	                Date.now() - loadingStarted;

	            const remaining =
	                Math.max(
	                    0,
	                    minimumLoadingTime - elapsed
	                );

	            window.setTimeout(
	                () =>
	                {
	                    if(
	                        requestId
	                        !==
	                        panoramaObservationRequestId.current
	                    )
	                    {
	                        return;
	                    }

	                    setPanoramaObservationList(
	                        Array.isArray(data)
	                            ?
	                            data
	                            :
	                            []
	                    );

	                    setPanoramaObservationListLoading(false);
	                },
	                remaining
	            );
	        },

	        null
	    );
	}
	
	
	//--------------------------------------------------------
	// Potential asset list for panorama
	//--------------------------------------------------------

	function loadPotentialAssetListForPanorama(
	    giraffePanoramaId)
	{
	    if(
	        giraffePanoramaId === null
	        ||
	        giraffePanoramaId === undefined
	        ||
	        giraffePanoramaId === ""
	    )
	    {
	        panoramaPotentialAssetRequestId.current++;

	        setPanoramaPotentialAssetList([]);
	        setPanoramaPotentialAssetListLoading(false);

	        return;
	    }

	    const requestId =
	        ++panoramaPotentialAssetRequestId.current;

	    const loadingStarted =
	        Date.now();

	    const minimumLoadingTime =
	        2000;

	    setPanoramaPotentialAssetListLoading(true);

	    functions.getArrayFromAjax(
	        "/resolutionsoftwareplatform/potentialassets/listbypanorama"
	        +
	        "?giraffePanoramaId="
	        +
	        encodeURIComponent(giraffePanoramaId),

	        (data) =>
	        {
	            const elapsed =
	                Date.now() - loadingStarted;

	            const remaining =
	                Math.max(
	                    0,
	                    minimumLoadingTime - elapsed
	                );

	            window.setTimeout(
	                () =>
	                {
	                    if(
	                        requestId
	                        !==
	                        panoramaPotentialAssetRequestId.current
	                    )
	                    {
	                        return;
	                    }

	                    setPanoramaPotentialAssetList(
	                        Array.isArray(data)
	                            ?
	                            data
	                            :
	                            []
	                    );

	                    setPanoramaPotentialAssetListLoading(false);
	                },
	                remaining
	            );
	        },

	        null
	    );
	}
	
	
	//--------------------------------------------------------
	// Clear panorama observation list
	//--------------------------------------------------------

	function clearPanoramaObservationList()
	{
	    panoramaObservationRequestId.current++;

	    setPanoramaObservationList([]);
	    setPanoramaObservationListLoading(false);
	}


	//--------------------------------------------------------
	// Clear panorama potential asset list
	//--------------------------------------------------------

	function clearPanoramaPotentialAssetList()
	{
	    panoramaPotentialAssetRequestId.current++;

	    setPanoramaPotentialAssetList([]);
	    setPanoramaPotentialAssetListLoading(false);
	}
	
	
	//--------------------------------------------------------
	// Dashboard
	//--------------------------------------------------------

	function loadDashboard()
	{
	    setDashboardLoading(true);

	    functions.getObjectFromAjax(
	        "/resolutionsoftwareplatform/insights/dashboard",

	        (data) =>
	        {
	            setDashboard(data);
	            setDashboardLoading(false);
	        },

	        null
	    );
	}
	
	
	//--------------------------------------------------------
		// Load dashboard insights using arbitrary filters
		//--------------------------------------------------------

		const loadDashboardInsightList =
		    async (filters = {}) =>
		    {
		        setInsightListLoading(
		            true
		        );


		        try
		        {
		            const params =
		                new URLSearchParams();


		            Object.keys(filters).forEach(
		                (key) =>
		                {
		                    const value =
		                        filters[key];


		                    if(
		                        value !== null
		                        &&
		                        value !== undefined
		                        &&
		                        String(value).trim() !== ""
		                    )
		                    {
		                        params.append(
		                            key,
		                            value
		                        );
		                    }
		                }
		            );


		            const response =
		                await axios.get(
		                    "/insights/dashboard/filter?"
		                    +
		                    params.toString()
		                );


		            setInsightList(
		                response.data
		                ||
		                []
		            );


		            return (
		                response.data
		                ||
		                []
		            );
		        }
		        catch(error)
		        {
		            console.error(
		                "ERROR LOADING DASHBOARD INSIGHTS:",
		                error
		            );


		            setInsightList(
		                []
		            );


		            return [];
		        }
		        finally
		        {
		            setInsightListLoading(
		                false
		            );
		        }
		    };
			
			
			//--------------------------------------------------------
			// Load insight list for risk
			//--------------------------------------------------------

			const loadInsightListForRisk =
			    async (
			        probability,
			        consequence
			    ) =>
			    {
			        setInsightListLoading(
			            true
			        );

			        try
			        {
			            const response =
			                await axios.get(
			                    "/resolutionsoftwareplatform/insights/listbyrisk",
			                    {
			                        params:
			                        {
			                            probability,
			                            consequence
			                        }
			                    }
			                );


			            setInsightList(
			                response.data
			                ||
			                []
			            );
			        }
			        catch(error)
			        {
			            console.error(
			                "Unable to load insight list for risk:",
			                error
			            );

			            setInsightList(
			                []
			            );
			        }
			        finally
			        {
			            setInsightListLoading(
			                false
			            );
			        }
			    };


			//--------------------------------------------------------
			// Return
			//--------------------------------------------------------

			return {
			    dashboard,
			    dashboardLoading,

			    insightsByCategory,
			    insightList,
			    panoramaInsightList,
			    panoramaObservationList,
			    panoramaPotentialAssetList,
			    insight,

			    loading,
			    insightListLoading,
			    panoramaInsightListLoading,
			    panoramaObservationListLoading,
			    panoramaPotentialAssetListLoading,
			    insightLoading,

			    loadDashboard,

			    loadInsightListForCategory,
			    loadInsightListForRisk,
			    loadInsightListForPanorama,
			    loadObservationListForPanorama,
			    loadPotentialAssetListForPanorama,
			    loadInsight,

			    clearPanoramaInsightList,
			    clearPanoramaObservationList,
			    clearPanoramaPotentialAssetList,
			    clearInsight,

			    refresh:
			        loadInsightsByCategory
			};
	
	
}